var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2FillDocument = function SvgS2FillDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 160,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "s2_fill_document_svg__a",
    width: 161,
    height: 162,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M80.5 61.91V27.79a12.03 12.03 0 0 0-.976-.049H48.34c-6.66 0-12.06 5.4-12.06 12.06v80.4c0 6.661 5.4 12.06 12.06 12.06h64.32c6.66 0 12.06-5.399 12.06-12.06V72.936c0-.328-.022-.652-.048-.976H90.55c-5.541 0-10.05-4.508-10.05-10.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M90.55 63.92h30.15L88.54 31.76v30.15c0 1.108.901 2.01 2.01 2.01Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s2_fill_document_svg__b)",
    mask: "url(#s2_fill_document_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139.142,
    height: 139.142,
    x: 10.929,
    y: 10.43,
    fill: "#FFECCF",
    rx: 3.461
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s2_fill_document_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFECCF",
    d: "M10.929 10.43H150.07v139.142H10.929z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.603,
    cy: 15.826,
    r: 60.534,
    fill: "url(#s2_fill_document_svg__d)",
    transform: "rotate(-.08 89.603 15.826)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s2_fill_document_svg__e)",
    d: "M64.036-14.149a33.407 33.407 0 0 0-34.95-.105l-107.276 65.5c-10.507 6.415-10.524 21.556-.032 27.996l106.567 65.406a33.408 33.408 0 0 0 34.95-.023l106.347-65.468c10.436-6.425 10.455-21.482.032-27.932L64.036-14.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s2_fill_document_svg__f)",
    d: "M30.981 76.492c2.378-51.946 46.417-92.128 98.362-89.75 51.946 2.378 92.128 46.416 89.75 98.362s-46.416 92.128-98.362 89.75c-51.945-2.378-92.128-46.416-89.75-98.362Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s2_fill_document_svg__g)",
    d: "M-45.444 110.743c20.649-8.809 42.918-8.432 62.211-.727 38.607 15.456 61.07 5.9 76.651-32.618 7.761-19.328 22.913-35.697 43.585-44.516 41.33-17.604 89.044 1.498 106.623 42.705 17.58 41.208-1.662 88.847-42.982 106.474-20.718 8.839-43.03 8.425-62.353.65-38.544-15.373-60.965-5.781-76.526 32.783-7.78 19.283-22.93 35.596-43.578 44.405-41.297 17.617-89.01-1.485-106.58-42.669-17.57-41.185 1.652-88.87 42.95-106.487Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.961,
    cy: 35.567,
    r: 60.534,
    fill: "url(#s2_fill_document_svg__h)",
    transform: "rotate(-.08 141.961 35.567)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "s2_fill_document_svg__e",
    x1: -24.039,
    x2: 202.179,
    y1: 134.773,
    y2: -2.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8480FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8480FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s2_fill_document_svg__f",
    x1: 157.501,
    x2: 60.454,
    y1: 36.06,
    y2: 140.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s2_fill_document_svg__g",
    x1: 39.564,
    x2: 211.601,
    y1: 154.815,
    y2: 58.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7D00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    stopColor: "#FC7D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#FC7D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7D00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s2_fill_document_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 36.888 52.715) scale(60.5342)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FF709F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF709F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s2_fill_document_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 53.197 88.764) scale(60.5342)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#EB1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s2_fill_document_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139.142,
    height: 139.142,
    x: 10.929,
    y: 10.43,
    fill: "#fff",
    rx: 3.461
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s2_fill_document_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.929 10.43H150.07v139.142H10.929z"
  })))));
};
export default SvgS2FillDocument;